<template>
  <div class="core-box">
    <div class="section-title">
      <img class="" src="../assets/images/core-title.png" alt="" />
    </div>
    <div class="core-main">
      <div class="core-list" :class="'core-list' + index" v-for="(item, index) in corelist" :key="index">
        <div  class="ac-core">
          <img :src="item.imgUrl" alt="" />
          <div class="core-bottom">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </div>
        <div class="ho-core">
          <img :src="item.imgUrlBg" alt="" />
          <div class="ho-bsx">
              <h3>{{ item.title }}</h3>
          <p>{{item.hotext}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      corelist: [
        {
          title: '政企合作经验深厚',
          text:
            '十几年政企合作经验，深入理解行业管理痛点。服务9个部委、135个协会、62家企业（央企和国企）。',
          imgUrl: require('../assets/images/core-list1.png'),
          imgUrlBg: require('../assets/images/core-list1-bg.png'),
          hotext: '十几年政企合作经验，深入理解行业管理痛点。服务9个部委、135个协会、62家企业（央企和国企）。'
        },
        {
          title: '业务渠道覆盖全国',
          text: '30个省份、2200条渠道，下沉至区县，项目可快速落地。',
          imgUrl: require('../assets/images/core-list2.png'),
          imgUrlBg: require('../assets/images/core-list2-bg.png'),
          hotext: '30个省份、2200条渠道，下沉至区县，项目可快速落地。'
        },
        {
          title: '专业化团队',
          text: '专业化团队运营，丰富的行业经验，全方位服务保障，成就行业口碑。',
          imgUrl: require('../assets/images/core-list3.png'),
          imgUrlBg: require('../assets/images/core-list3-bg.png'),
          hotext: '专业化团队运营，丰富的行业经验，全方位服务保障，成就行业口碑。'
        },
        {
          title: '多元化产品',
          text: '拥有9个管理平台、12个培训平台、200个考核平台，覆盖管理、培训、考核等多条产品线。',
          imgUrl: require('../assets/images/core-list4.png'),
          imgUrlBg: require('../assets/images/core-list4-bg.png'),
          hotext: '拥有9个管理平台、12个培训平台、200个考核平台，覆盖管理、培训、考核等多条产品线。'
        },
        {
          title: '教育资源丰富',
          text:
            '专业资源制作团队，超500名各行业专家，15%为正高级专家。累计研发10万道试题，50000+学时课程，涵盖12个行业领域，供全国千万用户使用。',
          imgUrl: require('../assets/images/core-list5.png'),
          imgUrlBg: require('../assets/images/core-list1-bg.png'),
          hotext: '专业资源制作团队，超500名各行业专家，15%为正高级专家。累计研发10万道试题，50000+学时课程，涵盖12个行业领域，供全国千万用户使用。'
        }
      ]
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/coreView.vue